import React from "react";
import Image from "../../elements/Image";
import Banner from "../../../assets/images/front/banner.webp";
import Profile from "../../../assets/images/front/profile.webp";
const CompanyBanner = () => {
  return (
    <section className="py-20 bg-palatte2 h-auto md:h-[500px] relative flex items-center overflow-hidden">
      <div className="absolute left-0 top-0 w-full h-full">
        <Image src={Banner} alt={""} classes={"object-cover dark:mix-blend-multiply"} />
      </div>
      <div className="relative w-full px-5 lg:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-7xl 3xl:max-w-9xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="flex flex-col items-start justify-center pt-10 md:pt-0">
            <h1 className="text-4xl 2xl:text-4xl font-bold text-white mb-2">
              {" "}
              Explore Companies
            </h1>
            <h2 className="text-xl 2xl:text-2xl text-white ">
              Connecting talent with the right opportunities
            </h2>
          </div>
          <div className="pt-0 md:pt-16">
            <div className="max-w-xl w-full ml-auto">
              <Image src={Profile} alt={""} classes={"object-contain"} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyBanner;
